import { Logo } from "./Logo";

const LINKS = [
  { label: "Expertise", href: "#expertise" },
  { label: "Approach", href: "#approach" },
  { label: "About", href: "#about" },
  { label: "Vision", href: "#vision" },
];

export function Footer() {
  return (
    <footer className="relative border-t border-hairline bg-background">
      <div className="mx-auto max-w-[1400px] px-6 py-14 md:px-10 lg:py-16">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-start">
          <div>
            <Logo className="w-[172px]" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-muted-foreground">
              Designing, building, deploying and operating modern technology.
            </p>
          </div>

          <nav aria-label="Footer" className="flex flex-wrap gap-x-8 gap-y-3 lg:justify-end">
            {LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="group relative text-[0.7rem] tracked text-muted-foreground transition-colors duration-300 hover:text-foreground"
              >
                {link.label}
                <span
                  aria-hidden="true"
                  className="absolute -bottom-1.5 left-0 h-px w-0 bg-primary transition-[width] duration-500 group-hover:w-full"
                />
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-hairline pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Billionaire Mindset Technologies
          </p>
          <p className="num text-[0.65rem] tracked text-muted-foreground/70">
            Design · Build · Deploy · Operate
          </p>
        </div>
      </div>
    </footer>
  );
}
